import { useState } from 'react'
import { privatenotes } from '../../../services/data'
import { toast, ToastContainer } from 'react-toastify'
import { useStoreId } from '../../../hooks/geturlstoreid'

const EditPrivateNotes = ({
  closePopup,
  ticketid,
  ticketnotes,
  noteid,
  refreshNotes
}) => {
  const [text, setText] = useState(ticketnotes || '')
  const [loading, setLoading] = useState(false)
  const wordLimit = 500
  const notesService = new privatenotes()
  console.log(ticketid, ticketnotes)

  const handleChange = e => {
    const words = e.target.value.split(/\s+/).filter(Boolean)
    if (words.length <= wordLimit) {
      setText(e.target.value)
    }
  }

  const handleUpdate = async () => {
    setLoading(true)
    const updatedData = {
      ticket_id: ticketid,
      store_id: useStoreId,
      ticket_notes: text,
      meta: {}
    }

    console.log(updatedData)

    try {
      const response = await notesService.updateNote(noteid, updatedData)
      console.log('Update response:', response)
      closePopup()
      refreshNotes?.()
      if (!toast.isActive(14, 'updatenotes')) {
        toast.success(response.message, {
          position: 'bottom-center',
          autoClose: true,
          closeOnClick: true,
          toastId: 14
        })
      }
    } catch (error) {
      console.error('Error updating note:', error)
      alert('Failed to update note. Please check if the note exists.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100] p-5'>
      <div
        className='bg-white shadow-lg w-full max-w-[850px] mx-auto my-[30px] rounded-[24px] border border-white overflow-y-auto min-h-[40%] max-h-[99%] h-[298px] scrollbar-hide'
        style={{ boxShadow: '-1px 0px 0px 0px #DFE5F1 inset' }}
      >
        {/* Top Header */}
        <div className='flex sticky top-0 bg-[#F1F1F1] w-full py-5 items-center px-5 justify-between border-[#E5E9EB] z-10'>
          <h2 className='text-[19px] font-bold'>Edit Note</h2>
          <button
            className='w-[30px] h-[30px] flex justify-center items-center rounded-full text-[14px] sm:text-[18px] cursor-pointer'
            aria-label='Close'
            onClick={closePopup}
          >
            <svg
              width='30'
              height='30'
              viewBox='0 0 30 30'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.10041 7.77459C8.7343 7.40847 8.1407 7.40847 7.77459 7.77459C7.40847 8.1407 7.40847 8.7343 7.77459 9.10041L13.6742 15L7.77459 20.8996C7.40847 21.2657 7.40847 21.8593 7.77459 22.2254C8.1407 22.5915 8.7343 22.5915 9.10041 22.2254L15 16.3258L20.8996 22.2254C21.2657 22.5915 21.8593 22.5915 22.2254 22.2254C22.5915 21.8593 22.5915 21.2657 22.2254 20.8996L16.3258 15L22.2254 9.10041C22.5915 8.7343 22.5915 8.1407 22.2254 7.77459C21.8593 7.40847 21.2657 7.40847 20.8996 7.77459L15 13.6742L9.10041 7.77459Z'
                fill='#000'
              />
            </svg>
          </button>
        </div>

        {/* Text area */}
        <div className='p-5 relative'>
          <textarea
            className='w-full min-h-[100px] border border-gray-300 rounded-lg p-3 resize-none focus:outline-none'
            value={text}
            onChange={handleChange}
            placeholder='Write your notes here...'
          ></textarea>
          <div className='text-gray-500 text-sm text-right mt-2 absolute bottom-7 right-7'>
            {text.split(/\s+/).filter(Boolean).length} / {wordLimit}
          </div>
        </div>

        {/* Bottom Buttons */}
        <div className='flex sticky bottom-0 bg-[#FFFFFF] w-full py-5 items-center px-5 justify-end gap-2 border-t-[1px] border-[#E5E9EB] z-10'>
          <button
            onClick={closePopup}
            className='rounded-[59px] border-[1px] border-[#DEDEDE] text-[14px] p-[10px] w-[85px] h-[39px]'
          >
            Cancel
          </button>
          <button
            onClick={handleUpdate}
            className='w-[85px] h-[39px] rounded-[59px] text-white text-[14px] bg-[#7C50DD] disabled:bg-gray-400'
          >
            Update
          </button>
        </div>
      </div>
      <ToastContainer containerId={'updatenotes'} />
    </div>
  )
}

export default EditPrivateNotes
